import React from 'react'
import { Input } from 'antd'

export default ({ input, field }) => {
  return <Input.Password name="airiot-password" autocomplete="new-password" {...input} {...field.attrs} />
}
